// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  jamReadyAt: __t.timestamp().name("jam_ready_at"),
  burstReadyAt: __t.timestamp().name("burst_ready_at"),
  resistUntil: __t.timestamp().name("resist_until"),
  reqRing: __t.string().name("req_ring"),
  jams: __t.u32(),
  bursts: __t.u32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
